import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import VideoCard from '@/components/feature/VideoCard';
import { categories as allCategories } from '@/mocks/home';
import { categoryVideos } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'fashion-tips');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeSlug]);

  const currentCategory = allCategories.find((c) => c.slug === activeSlug);
  const videos = categoryVideos[activeSlug] || [];

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: currentCategory?.name || '分类' },
            ]}
          />

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              {currentCategory?.name || '分类浏览'}
            </h1>
            <p className="text-sm text-foreground-500">
              共 {currentCategory?.count?.toLocaleString() || 0} 个精彩视频等你发现
            </p>
          </div>

          <div className="flex flex-wrap gap-2 mb-10 pb-2 overflow-x-auto">
            {allCategories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                onClick={() => setActiveSlug(cat.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 border border-background-200/70'
                }`}
              >
                <span className="mr-1">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
          </div>

          {videos.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6 pb-14">
              {videos.map((video) => (
                <VideoCard
                  key={video.id}
                  id={video.id}
                  title={video.title}
                  cover={video.cover}
                  duration={video.duration}
                  views={video.views}
                  author={video.author}
                  authorAvatar={video.authorAvatar}
                  slug={video.slug}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                <i className="ri-video-line text-3xl"></i>
              </div>
              <p className="text-foreground-500">该分类暂无视频内容，敬请期待</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}